import { styled } from '@mui/material';
import { SnackbarProvider } from 'notistack';

const StyledSnackbarProvider = styled(SnackbarProvider)`
  &.notistack-MuiContent-error {
    color: ${({ theme }) => theme.palette.getContrastText(theme.palette.error.dark)};
  }

  &.notistack-MuiContent-success {
    background-color: ${({ theme }) => theme.palette.success.main};
    color: ${({ theme }) => theme.palette.getContrastText(theme.palette.success.main)};
  }

  &.notistack-MuiContent-info {
    background-color: ${({ theme }) => theme.palette.info.main};
    color: ${({ theme }) => theme.palette.getContrastText(theme.palette.info.main)};
  }
`;

export default StyledSnackbarProvider;
